export interface Category {
  id: number;
  nameEn: string;
  namePl: string;
  url: string;
  description: string;
  imageSeq: string;
  icon: string;
}

export const categories: Category[] = [
  {
    id: 1,
    nameEn: 'Shoes',
    namePl: 'Buty',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    description: 'Buty sportowe, casualowe i eleganckie — znajdź idealną parę w arkuszu.',
    imageSeq: 'cat-shoes-01',
    icon: 'ri-footprint-line',
  },
  {
    id: 2,
    nameEn: 'Hoodies/Sweaters',
    namePl: 'Bluzy / Swetry',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    description: 'Ciepłe i stylowe bluzy oraz swetry na każdą porę roku.',
    imageSeq: 'cat-hoodies-02',
    icon: 'ri-shirt-line',
  },
  {
    id: 3,
    nameEn: 'T-Shirts',
    namePl: 'Koszulki',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    description: 'Klasyczne i designerskie koszulki — przeglądaj w arkuszu.',
    imageSeq: 'cat-tshirts-03',
    icon: 'ri-t-shirt-line',
  },
  {
    id: 4,
    nameEn: 'Jackets',
    namePl: 'Kurtki',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    description: 'Kurtki zimowe, przejściowe i wiatrówki w jednym arkuszu.',
    imageSeq: 'cat-jackets-04',
    icon: 'ri-windy-line',
  },
  {
    id: 5,
    nameEn: 'Pants/Shorts',
    namePl: 'Spodnie / Szorty',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    description: 'Spodnie dżinsowe, materiałowe i szorty — wszystko pod ręką.',
    imageSeq: 'cat-pants-05',
    icon: 'ri-ruler-line',
  },
  {
    id: 6,
    nameEn: 'Headwear',
    namePl: 'Nakrycia Głowy',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    description: 'Czapki, kapelusze i akcesoria na głowę w jednym miejscu.',
    imageSeq: 'cat-headwear-06',
    icon: 'ri-vip-crown-line',
  },
  {
    id: 7,
    nameEn: 'Sets',
    namePl: 'Zestawy',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    description: 'Kompletne zestawy ubrań — gotowe stylizacje w arkuszu.',
    imageSeq: 'cat-sets-07',
    icon: 'ri-stack-line',
  },
  {
    id: 8,
    nameEn: 'Underwear/Underpants',
    namePl: 'Bielizna',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    description: 'Bielizna i bokserki — wygodne i jakościowe produkty.',
    imageSeq: 'cat-underwear-08',
    icon: 'ri-heart-line',
  },
  {
    id: 9,
    nameEn: 'Jersey',
    namePl: 'Koszulki Sportowe',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    description: 'Koszulki sportowe i piłkarskie — sprawdź dostępne modele.',
    imageSeq: 'cat-jersey-09',
    icon: 'ri-basketball-line',
  },
  {
    id: 10,
    nameEn: 'Accessories',
    namePl: 'Akcesoria',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    description: 'Biżuteria, okulary i dodatki — uzupełnij swoją stylizację.',
    imageSeq: 'cat-accessories-10',
    icon: 'ri-glasses-line',
  },
  {
    id: 11,
    nameEn: 'Bags',
    namePl: 'Torby',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    description: 'Torby, plecaki i walizki — praktyczne i stylowe rozwiązania.',
    imageSeq: 'cat-bags-11',
    icon: 'ri-handbag-line',
  },
  {
    id: 12,
    nameEn: 'Belts',
    namePl: 'Paski',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    description: 'Paski skórzane i materiałowe — idealne dodatki do stylizacji.',
    imageSeq: 'cat-belts-12',
    icon: 'ri-links-line',
  },
  {
    id: 13,
    nameEn: 'Perfumes',
    namePl: 'Perfumy',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    description: 'Zapachy damskie i męskie — odkryj wyjątkowe perfumy.',
    imageSeq: 'cat-perfumes-13',
    icon: 'ri-drop-line',
  },
  {
    id: 14,
    nameEn: 'Other Stuff',
    namePl: 'Inne Produkty',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    description: 'Pozostałe produkty i akcesoria — sprawdź pełną ofertę.',
    imageSeq: 'cat-other-14',
    icon: 'ri-more-line',
  },
];